
/**
 * Verifica los campos del formulario del artículo.
 * @param {Object} form - El formulario del artículo.
 * @returns {Promise<boolean>} Una promesa que resuelve con true si los campos son válidos.
 * @throws {Error} Si hay un problema en la validación de los campos.
 */
export const verifyFields = async (form, isModify = false) => {

  try {
    // Validar cada campo del formulario
    if (!form.departament) {
      throw new Error("Selecciona un departamento para el artículo");
    }
    if (!form.subdepartament) {
      throw new Error("Selecciona un subdepartamento para el artículo");
    }
    if (!form.code) {
      throw new Error("Ingresa una clave para el artículo");
    }
    if (!form.name) {
      throw new Error("Ingresa el nombre del artículo");
    }
    if (!form.image) {
      throw new Error("Selecciona una imagen para el artículo");
    }
    if (!form.cost) {
      throw new Error("Ingresa el costo del artículo");
    }
    if (!form.price) {
      throw new Error("Ingresa el precio del artículo");
    }
    if (
      isNaN(form.price) ||
      isNaN(form.cost) ||
      form.price < 0 ||
      form.cost < 0
    ) {
      throw new Error(
        "Ingresa solo valores numéricos para los campos de precio o costo"
      );
    }
    if (form.price <= form.cost) {
      throw new Error("El precio debe ser mayor al costo");
    }

    if (!form.deliveryTime) {
      throw new Error(
        "Ingresa el tiempo de entrega de resultados para el artículo"
      );
    }
    if (!form.description) {
      throw new Error("Ingresa una descripcion");
    }

    if (form.description && form.description.length < 10) {
      throw new Error(
        "Ingresa al menos 10 caracteres dentro de la descripción"
      );
    }
    if (!form.req) {
      throw new Error("Ingresa los requisitos");
    }
    if (form.req && form.req.length < 10) {
      throw new Error("Ingresa al menos 10 caracteres dentro de requisitos");
    }
    if (isModify && !form.recomd) {
      throw new Error("Ingresa las recomendaciones");
    }
    if (isModify && form.recomd && form.recomd.length < 10) {
      throw new Error("Ingresa al menos 10 caracteres dentro de recomendaciones");
    }
    // Si todas las validaciones pasan, retornar true
    return true;
  } catch (error) {
    console.error("Error en la validación de campos:", error.message);
    throw error;
  }
};
